import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { LocalStorageService } from 'ngx-webstorage';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import 'rxjs/add/observable/of';
import { environment } from '../../environments/environment';
import { CartItem } from '../models/cart-item.model';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ZipCodeComponent } from '../modules/shared/zip-code/zip-code.component';
import { eventsService } from './events.service';

@Injectable()
export class CartService {
  private serverUrl = environment.serverUrl;
  private items: Array<any> = [];
  private totalCartItems = 0;

  private totalCount = new BehaviorSubject<number>(0);
  totalCountStreem$ = this.totalCount.asObservable();

  constructor(private localSt: LocalStorageService,
    private http: HttpClient,
    private modalService: NgbModal,
    private EventsService: eventsService) {
    if (this.localSt.retrieve('cartItems')) {
      this.items = this.localSt.retrieve('cartItems');
    }
    this.localSt.observe('cartItems').subscribe((items) => {
      items ? this.items = items : this.items = [];
    });
  }

  youMayEnjoy(data): Observable<any> {
    const params = 'items/suggestion/youmayenjoy';
    return this.http.put(this.serverUrl + params, data);
  }

  applyPromo(data): Observable<any> {
    return this.http.get(this.serverUrl + 'promocodes/code/' + data);
  }

  // Add item function
  public addItem(item: CartItem) {
    // tslint:disable-next-line:max-line-length
    let selectedDate = this.localSt.retrieve('selectedDate').fullDate;
    if (!this.localSt.retrieve('zenUser') && !this.localSt.retrieve('validZipCode') && (!this.localSt.retrieve('cartItems') || !this.localSt.retrieve('cartItems').length)) {
      this.modalService.open(ZipCodeComponent, { backdrop: 'static', keyboard: false }).result.then((response) => {
        if (response) {
          const obj = this.items.find((dateObj, i) => {
            if (dateObj.date === selectedDate) {
              const underObj = dateObj.items.find((cartItem, i) => {
                if (cartItem.zf_id === item.zf_id) {
                  cartItem.count++;
                  return true;
                }
              });
              if (!underObj) {
                item.count = 1;
                dateObj.items.push({ ...item });
              }
              return true;
            }
          });
          if (!obj) {
            item.count = 1;
            const pushObj = {
              date: selectedDate,
              items: [{ ...item }]
            };
            this.items.push(pushObj);
          }
          this.localSt.store('cartItems', this.items);
        }
      });
    } else {
      const obj = this.items.find((dateObj, i) => {
        if (dateObj.date === selectedDate) {
          const underObj = dateObj.items.find((cartItem, i) => {
            if (cartItem.zf_id === item.zf_id) {
              cartItem.count++;
              return true;
            }
          });
          if (!underObj) {
            item.count = 1;
            dateObj.items.push({ ...item });
          }
          return true;
        }
      });
      if (!obj) {
        item.count = 1;
        const pushObj = {
          date: selectedDate,
          items: [{ ...item }]
        };
        this.items.push(pushObj);
      }
      this.localSt.store('cartItems', this.items);
      // Added To Cart Event Log
      if (this.localSt.retrieve('zenUser')) {
        this.EventsService.addedToCartEvent(this.items, { item, selectedDate }).subscribe(obs => {
          // Do nothing
        });
      }
    }
  }

  public addSuggestedItem(item: CartItem, date) {
    const obj = this.items.find((dateObj, i) => {
      if (dateObj.date === date) {
        const underObj = dateObj.items.find((cartItem, i) => {
          if (cartItem.zf_id === item.zf_id) {
            cartItem.count++;
            return true;
          }
        });
        if (!underObj) {
          item.count = 1;
          dateObj.items.push({ ...item });
        }
        return true;
      }
    });
    this.localSt.store('cartItems', this.items);
    // Added To Cart Event Log
    if (this.localSt.retrieve('zenUser')) {
      this.EventsService.addedToCartEvent(this.items, { item, selectedDate: date }).subscribe(obs => {
        // Do nothing
      });
    }
  }

  // Add item from my cart function
  public addItemFromCart(item: CartItem, date) {
    this.items.forEach(dateObj => {
      if (dateObj.date === date) {
        dateObj.items.forEach(cartItem => {
          if (cartItem.zf_id === item.zf_id) {
            cartItem.count++;
          }
        });
      }
    });
    this.localSt.store('cartItems', this.items);
    // Added To Cart Event Log
    if (this.localSt.retrieve('zenUser')) {
      this.EventsService.addedToCartEvent(this.items, { item, selectedDate: date }).subscribe(obs => {
        // Do nothing
      });
    }
  }

  // Remove item function
  public removeItem(item) {
    this.items.forEach((dateObj, i) => {
      if (dateObj.date === this.localSt.retrieve('selectedDate').fullDate) {
        dateObj.items.forEach((cartItem, index) => {
          if (cartItem.zf_id === item.zf_id) {
            if (cartItem.count >= 2) {
              cartItem.count--;
            } else {
              item.count = null;
              dateObj.items.splice(index, 1);
            }
          }
        });
      }
      if (!dateObj.items.length) {
        this.items.splice(i, 1);
      }
    });
    this.localSt.store('cartItems', this.items);
  }

  // Remove item from cart function
  public removeItemFromCart(item, date) {
    this.items.forEach((dateObj, i) => {
      if (dateObj.date === date) {
        dateObj.items.forEach((cartItem, index) => {
          if (cartItem.zf_id === item.zf_id) {
            if (cartItem.count >= 2) {
              cartItem.count--;
            } else {
              item.count = null;
              dateObj.items.splice(index, 1);
            }
          }
        });
      }
      if (!dateObj.items.length) {
        this.items.splice(i, 1);
      }
    });
    this.localSt.store('cartItems', this.items);
  }

  // public addItem(item: CartItem) {
  //   // search if this item already exists in array
  //   // if exist increase count
  //   // else simply push (as new element) in array
  //   const obj = this.items.find((o, i) => {
  //     if (o.zf_id === item.zf_id) {
  //       if (!this.items[i].count) {
  //         this.items[i].count = 1;
  //       }
  //       this.items[i].count++;
  //       item.count = this.items[i].count;
  //       return true;
  //     }
  //   });
  //   // If item not found in array add
  //   if (!obj) {
  //     item.count = 1;
  //     // make a copy and push , remove referece
  //     this.items.push({...item});
  //   }
  //   // Update local storage
  //   this.saveInLocalStorage();
  // }


  public getAllItems(): Array<CartItem> {
    return this.items;
  }

  public isItemExists(item) {
    // Search given item in existing list
    // Increase count as item object is passed by refernce
    const obj = this.items.find((o, i) => {
      if (o.zf_id === item.zf_id) {
        item.count = this.items[i].count;
        return true;
      }
    });
    return obj;
  }

  // public removeItem(item): boolean {
  //   let obj = null;
  //   obj = this.items.forEach((o, i) => {
  //     if (o.zf_id === item.zf_id) {
  //       // if item exist and count is greate then 2 minus it.
  //       // else delete count and remove item from array.
  //       if (this.items[i] && this.items[i].count >= 2) {
  //         this.items[i].count--;
  //         item.count--;
  //       } else {
  //         item.count = null;
  //         this.items.splice(i, 1);
  //       }
  //       return true;
  //     }
  //     return false;
  //   });
  //   this.saveInLocalStorage();
  //   return obj ? true : false;
  // }

  public _totalCount(): number {
    this.totalCartItems = 0;
    this.items.forEach((o, i) => {
      // each cart item contians total count so just add them up
      this.totalCartItems += o.count;
    });
    this.totalCount.next(this.totalCartItems);

    // update total cound in localstorage which will also trigger event
    // this.localSt.store('totalCartItems', this.totalCartItems);
    return this.totalCartItems;
  }

  public saveInLocalStorage() {
    // before save count item
    this._totalCount();
    // save complete cart and count in localstorage
    this.localSt.store('cartItems', this.items);
    this.localSt.store('totalCartItems', this.totalCartItems);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/cart.service.ts